import { useTicketEmails } from '../../hooks/queries/useTickets';

import { formatAppDate } from '../../lib/dateFormat';
interface TicketCorrespondenceProps {
  ticketId: string;
}

/**
 * Historique des emails ENVOYÉS AU CANDIDAT (ticket_emails).
 * À ne pas confondre avec TicketNotes (notes internes, qui restent au cabinet).
 */
export function TicketCorrespondence({ ticketId }: TicketCorrespondenceProps) {
  const { data: emails } = useTicketEmails(ticketId);

  if (!emails || emails.length === 0) return null;

  return (
    <div className="space-y-2">
      <h3 className="text-sm font-semibold text-cime-text-primary">
        Correspondance envoyée au candidat
      </h3>
      <div className="space-y-2">
        {emails.map((mail) => (
          <details
            key={mail.id}
            className="rounded-cime border border-neutral-200 bg-cime-surface px-3 py-2"
          >
            <summary className="cursor-pointer text-sm text-neutral-700 flex items-center justify-between gap-3">
              <span className="truncate">{mail.subject}</span>
              <span className="shrink-0 text-xs text-neutral-400">
                {formatAppDate(mail.sent_at)}
                {mail.status === 'failed' && (
                  <span className="ml-2 text-red-600 font-medium">échec</span>
                )}
              </span>
            </summary>
            <div className="mt-2 border-t border-neutral-100 pt-2">
              <p className="text-xs text-neutral-400 mb-1">À : {mail.to_email}</p>
              <p className="whitespace-pre-wrap text-sm text-neutral-700">{mail.body}</p>
              {mail.status === 'failed' && mail.error && (
                <p className="mt-2 text-xs text-red-600">Erreur : {mail.error}</p>
              )}
            </div>
          </details>
        ))}
      </div>
    </div>
  );
}
